import { getCartToken, setCartToken } from 'helpers/shop';
import { axiosApiInstance, axiosPlainApi } from 'helpers/api';

export const ADD_PRODUCT = '@services/ADD_PRODUCT';
export const UPDATE_PRODUCTS = '@services/UPDATE_PRODUCTS';
export const CHANGE_QUANTITY = '@services/CHANGE_QUANTITY';
export const SHIPPING_CHARGE_UPDATE = '@services/SHIPPING_CHARGE_UPDATE';
export const NEXT_STEP_SUCCESS = '@services/NEXT_STEP_SUCCESS';
export const STEP_SUCCESS = '@services/STEP_SUCCESS';
export const BACK_STEP_SUCCESS = '@services/BACK_STEP_SUCCESS';
export const BILLING_ADDRESS = '@services/BILLING_ADDRESS';
export const DELIVERY_TYPE = '@services/DELIVERY_TYPE';

export const addProduct = (product, exsingProducts) => {
    return (dispatch, getState) => {
        const state = getState();
        if (state) {
            const cartToken = getCartToken();
            const payload = {
                ...product,
                cart_token: cartToken || null
            };
            return axiosPlainApi.post('/api/shop/cart', payload).then((response) => {
                if (response?.data?.cart_token) {
                    setCartToken(response?.data?.cart_token);
                }
                dispatch({
                    type: ADD_PRODUCT,
                    payload: product
                });
            });
        } else return null;
    };
};

export const updateCartData = () => {
    return (dispatch, getState) => {
        const state = getState();
        if (state) {
            const cartToken = getCartToken();
            //console.log('cartToken', cartToken);
            if (cartToken) {
                return axiosPlainApi.get('/api/shop/cart-details/' + cartToken).then((response) => {
                    dispatch({
                        type: UPDATE_PRODUCTS,
                        payload: response.data
                    });
                });
            }
        }
    };
};

export const setPaymentCard = (product, exsingProducts) => {
    //console.log('Addproducts', product, exsingProducts);
    return (dispatch, getState) => {
        const state = getState();
        if (state) {
            dispatch({
                type: ADD_PRODUCT,
                payload: product
            });
        } else return null;
    };
};

export const setPaymentMethod = (product, exsingProducts) => {
    return (dispatch, getState) => {
        const state = getState();
        if (state) {
            dispatch({
                type: ADD_PRODUCT,
                payload: product
            });
        } else return null;
    };
};

export const removeProduct = (id, products) => {
    return async (dispatch, getState) => {
        const state = getState();

        if (!state) return null;

        const cartToken = getCartToken();
        if (!cartToken) return null;

        const payload = {
            product_id: id,
            quantity: 0,
            action: 'remove'
        };

        try {
            const response = await axiosPlainApi.post('/api/shop/cart-update/' + cartToken, payload);

            dispatch({
                type: CHANGE_QUANTITY,
                payload: response.data
            });
        } catch (error) {
            console.error('Failed to update product:', error);
        }
    };
};

export const setDeliveryData = (deliveryType, deliveryAddress) => {
    return (dispatch, getState) => {
        const state = getState();
        if (state) {
            dispatch({
                type: DELIVERY_TYPE,
                payload: {
                    deliveryType,
                    deliveryAddress
                }
            });
        } else return null;
    };
};

export const setBackStep = () => {
    return (dispatch, getState) => {
        const state = getState();
        if (state) {
            dispatch({
                type: BACK_STEP_SUCCESS
            });
        } else return null;
    };
};

export const setBillingAddress = (address) => {
    return (dispatch, getState) => {
        const state = getState();
        if (state) {
            dispatch({
                type: BILLING_ADDRESS,
                payload: address
            });
        } else return null;
    };
};

export const setNextStep = () => {
    return (dispatch, getState) => {
        const state = getState();
        if (state) {
            dispatch({
                type: NEXT_STEP_SUCCESS
            });
        } else return null;
    };
};
export const setShippingCharge = (deliveryType) => {
    return (dispatch, getState) => {
        const state = getState();
        if (state) {
            const cartToken = getCartToken();
            const type = deliveryType || state?.cart?.checkout?.delivery?.type;
            const payload = {
                products: state?.cart?.checkout?.products,
                delivery_type: type
            };
            if (cartToken) {
                return axiosApiInstance.post('/api/shop/shipping-charge/' + cartToken, payload).then((response) => {
                    dispatch({
                        type: SHIPPING_CHARGE_UPDATE,
                        payload: response.data
                    });
                });
            }
        }
    };
};
export const setStep = (step) => {
    return (dispatch, getState) => {
        const state = getState();
        if (state) {
            dispatch({
                type: STEP_SUCCESS,
                payload: step
            });
        } else return null;
    };
};

export const updateProduct = (id, quantity, products) => {
    return async (dispatch, getState) => {
        const state = getState();

        if (!state) return null;

        const cartToken = getCartToken();
        if (!cartToken) return null;

        const payload = {
            product_id: id,
            quantity: quantity,
            action: 'change_quantity'
        };

        try {
            const response = await axiosPlainApi.post('/api/shop/cart-update/' + cartToken, payload);

            dispatch({
                type: CHANGE_QUANTITY,
                payload: response.data
            });
        } catch (error) {
            console.error('Failed to update product:', error);
        }
    };
};
